import React from "react";
import ReactDOM from "react-dom";
import {Overlay, Popover} from "react-bootstrap";
import StyledSelect from 'core/components/fields/styledSelect';
import {fieldStyles} from 'core/form/createForm';
import FaFilter = require("react-icons/lib/fa/filter");
import {observer} from "mobx-react";
import styled from "styled-components";
import {grey400} from "material-ui/styles/colors";
import {Task} from "core/event/eventDomain";
import {ZzFlatButton} from "core/components/buttons/buttons";
import {PERMISSION} from "core/metamodel/metaConstant";
import {lovValue} from "core/form/formUtils";
import securityService from "core/security/securityService";
import {action} from "mobx";
import {LovItem} from "core/metamodel/mdEntity";
import {optionsSearch} from "core/common/service/commonDataService";


interface Props {
  taskObject: Task;
  onAssign: (username: string) => Promise<any>;
}
interface State {
  showPopover?: boolean,
  owner?: LovItem
  ownerError?: string;
}

const PopoverStyled = styled(Popover)`
    min-width: 200px;
    z-index: 1600px;
`;

const TitleP = styled.p`
    color: ${grey400};
    font-size: 18px;
`;

const ButtonDiv = styled.div`
  display: flex;
  justify-content: space-around;
  margin-top: 10px;
`;

const AssignDiv = styled.div`
    display: flex;
    flex-direction: column;
`;

const IconSpan = styled.span`
    float: right;
    cursor: pointer;
    margin: 6px;
`;


@observer
export default class AssignTaskComponent extends React.Component<Props, State> {

  state = {
    showPopover: false,
    owner: null,
    ownerError: null
  };

  buttonRef: React.ReactInstance;

  cancelPopover = (evt) => {
    this.setState({
      showPopover: false,
      owner: null,
      ownerError: null
    });
  };


  onChangeOwner = (ownerLov: LovItem) => {
    this.setState({owner: ownerLov});
  };


  @action onOpen = (evt) => {
    this.setState({
      showPopover: true,
      owner: null,
      ownerError: null
    });
  };

  @action assignToMe = (evt) => {
    console.log("assign to me");
    return this.props.onAssign(securityService.currentUser.username)
      .then(() => {
        this.cancelPopover(null);
      })
  };

  @action assignToOther = (evt) => {
    console.log("assign to other");
    if (!this.state.owner) {
      this.setState({ownerError: 'Select User'})
    } else {
      return this.props.onAssign(this.state.owner.value)
        .then(() => {
          this.cancelPopover(null);
        })
    }
  };




  buttonRefHandler = comp => this.buttonRef = comp;
  onHideHandler = () => this.setState({showPopover: false});
  targetHandler = () => ReactDOM.findDOMNode(this.buttonRef);

  render() {

    let {taskObject} = this.props;


    return (
      <div ref={this.buttonRefHandler}>
        <ZzFlatButton  onClick={this.onOpen} label="Assign" permission={taskObject.$new ? PERMISSION.New : PERMISSION.Update}/>
        <Overlay
          show={this.state.showPopover}
          onHide={this.onHideHandler}
          rootClose
          target={this.targetHandler}
          placement="bottom">
            <PopoverStyled id="taskAssignPopover">
              <TitleP>
                <span><span>Assign Task</span> <IconSpan className="fa fa-close" onClick={this.cancelPopover} /></span>
              </TitleP>

              <ButtonDiv>
                {(lovValue(taskObject.owner) !== securityService.currentUser.username || 1===1) ? <ZzFlatButton label="Assign to me" secondary onClick={this.assignToMe} /> : null}
                <AssignDiv>
                <ZzFlatButton label="Assign to ..." secondary onClick={this.assignToOther} />
                <StyledSelect {...fieldStyles.small.styledSelect} style={{width:200, ...fieldStyles.small.styledSelect.style}}
                              onChange={this.onChangeOwner} value={this.state.owner}
                              async loadOptions={optionsSearch.bind(this, 'User', {currentTenantOnly: true})} clearable asterixForAll errorText={this.state.ownerError} />
                </AssignDiv>
              </ButtonDiv>
            </PopoverStyled>
        </Overlay>
      </div>

    );



  }
}





// WEBPACK FOOTER //
// ./src/core/event/component/assignTaskComponent.tsx